import { FormTemplate } from "components/modal/templates";
import Toggle from "components/shared/toggle";
import { ymEvent } from "helpers/system";
import { requiredField } from "helpers/validators";
import React from "react";
import { components } from "react-select";
import { apply } from "sources/books/cargoOwners";
import { get as partyLookups } from "sources/partyLookup";
import { config, initialState } from "../formConfig";
import { CounterpartyPlatformsForm } from "../platforms";

const Option = (props) => {
    const { name, inn } = props.data.option;
    return (
        <components.Option {...props}>
            {name} <small className="text-muted">ИНН: {inn}</small>
        </components.Option>
    );
};

class CreateCargoOwnerModal extends FormTemplate {
    sendRequest = (stateData) => {
        if (stateData.isInsolvent) {
            ymEvent("InsolventCounterparty");
        }
        return apply(stateData);
    };

    handleSelect = ({ option }) => {
        if (!option) {
            return;
        }
        const isValid = this.isValidForm({ ...this.state, ...option });
        this.setState({ ...option, ...(isValid ? { isValid: true } : {}) });
    };

    setValue = ({ name, value }) => {
        const newState = {
            ...this.state,
            [name]: value,
            ...(name === "isForeign" && value ? { manual: true } : {}),
        };
        const isValid = this.isValidForm(newState);
        this.setState({
            [name]: value,
            ...(name === "isForeign" && value ? { manual: true } : {}),
            ...(isValid ? { isValid: true } : {}),
        });
    };

    renderBodyInner = () => {
        const { config, enums } = this.props;
        const { manual, isForeign } = this.state;
        return (
            <>
                {this.renderCheckbox(config.isForeign)}
                {!isForeign && (
                    <div className="row form-group">
                        <div className="col-sm-8 col-md-9 offset-sm-4 offset-md-3">
                            <Toggle
                                fieldBeforeLabel
                                value={!manual}
                                onChange={(value) => this.setState({ manual: !value })}
                                label="Поиск по названию или ИНН"
                            />
                        </div>
                    </div>
                )}
                {!manual && !isForeign &&
                    this.renderSelect({
                        label: "Название или ИНН",
                        inputProps: { name: "nameOrInn" },
                        url: partyLookups,
                        propName: "name",
                        menuPortalTarget: document.body,
                        minimumInputLength: 2,
                        idKey: "inn",
                        onChange: this.handleSelect,
                        filterOption: (option, search) => {
                            if (!option.label) {
                                return false;
                            } else {
                                return search
                                    .toLowerCase()
                                    .split(" ")
                                    .every(
                                        (item) =>
                                            option.label.toLowerCase().indexOf(item) > -1 ||
                                            option.value.toLowerCase().indexOf(item) > -1,
                                    );
                            }
                        },
                        components: { Option },
                    })}
                {this.renderField({ ...config.name, disabled: !manual })}
                {this.renderField({ ...config.inn, disabled: !manual })}
                {this.renderField({ ...config.kpp, disabled: !manual })}
                {this.renderSelect(config.counterpartyGroupId)}
                {this.renderField(config.analyzeStrictOffsetHours)}
                {this.renderField(config.noteForDrivers)}
                {this.renderField(config.comment)}
                {this.renderSelect(config.status)}
                {this.renderCheckbox(config.isInsolvent)}
                {this.state.isInsolvent &&
                    this.renderField({ ...config.insolvencyComment, required: true, validators: [requiredField] })}
                <CounterpartyPlatformsForm platforms={this.state.platforms} onChange={this.setValue} enums={enums} />
            </>
        );
    };
}

const ConfiguredModal = (props) => (
    <CreateCargoOwnerModal {...props} config={config} initialState={{ ...initialState, manual: false }} />
);

export default ConfiguredModal;
